// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simx-content-container {
  width: 100%;
  height: 100%;
}
.simx-content-container.simx-scroll-content {
  overflow-y: auto;
}
.simx-content-container.simx-gutter {
  padding: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/ui-elements/components/containers/content-container/content-container.component.scss","webpack://./src/assets/styles/_layout.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,YAAA;AADF;AAGE;EACE,gBAAA;AADJ;AAGE;EACE,aCLyB;ADI7B","sourcesContent":["@use 'layout';\n\n.simx-content-container {\n  width: 100%;\n  height: 100%;\n\n  &.simx-scroll-content {\n    overflow-y: auto;\n  }\n  &.simx-gutter {\n    padding: layout.$simxContentContainerGutter;\n  }\n}\n","$simxAppHeaderHeight: 50px;\n\n$simxAppSidebarWidth: 240px;\n$simxAppSidebarGutter: 20px;\n\n$simxContentContainerGutter: 30px;\n\n$simxAdministrationViewPanelHeaderHeight: 45px;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
